import { Auth } from 'aws-amplify';
import config from '../config';

export const user = [{ role: 'signedout' }];

export async function setUserState(name, email) {
  const session = await Auth.currentSession();

  const response = await window.fetch(`${config.serverUrl}users/${email}?name=${name}`, {
    method: 'put',
    headers: {
      accesstoken: session.getAccessToken().getJwtToken(),
    },
  });
  const responseJson = await response.json();
  user[0] = responseJson;
}
